import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const WhyQuantumFloPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans min-h-screen mt-10">
      <HeadersNonAuth />
      <br />
      <br />

    <section id="why" className="bg-[#0b0d2a] text-white px-6 lg:px-24 py-16 font-sans">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold mb-8">Why Quantum Flo Auto Algo?</h2>

        <p className="text-xl font-semibold text-cyan-300 mb-4">
          Built by Hedge Fund Veterans. Powered by AI. Now in Your Hands.
        </p>

        <p className="mb-4">
          Quantum Flo isn’t just another trading bot—it’s the retail trader’s access point to a decade of hedge fund-grade technology. Developed by the same team behind a systematic hedge fund that's been deploying capital for over 10 years, the Quantum Flo Auto Algo is the first of its kind: a fully automated options trading system that mirrors institutional-grade strategies.
        </p>

        <p className="mb-4">
          This isn’t about selling options for scraps of premium.<br />
          We take directional bets. Every trade is driven by cutting-edge machine learning models designed to forecast price action and volatility with precision. Our algorithms dynamically scan market conditions to identify asymmetric risk/reward opportunities in SPX, SPY, and QQQ options with no manual intervention required.
        </p>

        <h3 className="text-2xl font-semibold text-white mt-8 mb-4">What Sets Us Apart?</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Hedge Fund DNA:</strong> We’ve traded these strategies with real capital for years. Now retail traders can benefit from the same quantitative edge.
          </li>
          <li>
            <strong>Daily Alpha, Delivered:</strong> Our AI models generate high-confidence trades each day, focused on buying options, not selling them.
          </li>
          <li>
            <strong>Proven Performance:</strong> With a high win rate and tight risk management, the results speak for themselves.
          </li>
          <li>
            <strong>Set It and Trade:</strong> Connect your broker. Confirm trade size. Let the algo do the rest.
          </li>
          <li>
            <strong>Real Autonomy:</strong> No alerts. No second-guessing. Just fully automated execution with total transparency and control.
          </li>
        </ul>

        <h3 className="text-2xl font-semibold text-white mt-8 mb-4">
          Welcome to the Next Evolution of Options Trading
        </h3>
        <p className="mb-6">
          The era of guesswork, gut trades, and guru "alerts" is over. Quantum Flo is the future, a trading system that learns, adapts, and executes with institutional intelligence, finally available to the individual trader.
        </p>
        <p className="font-semibold text-cyan-300">
          Start trading like the pros.<br />
          Let Quantum Flo work for you.
        </p>
      </div>
    </section>
    </div>
  );
};

export default WhyQuantumFloPage;
